import React from "react";

import { Input } from "src/common/components/Input";

type DateInputProps = Omit<React.ComponentProps<typeof Input>, "type">;

export const DateInput: React.FunctionComponent<DateInputProps> = props => (
	<Input {...props} type="date" max="9999-12-31" />
);
